import { Component, Input, OnInit } from "@angular/core";
import { NbDialogRef } from "@nebular/theme";
import { ColumnMode } from "@swimlane/ngx-datatable";
import { LocalDataSource } from "ng2-smart-table";
import { ApiService } from "../services/api.service";
import { DecimalPipe } from "@angular/common";

@Component({
    selector: "ngx-my-transactions-dialog",
    templateUrl: "./my-transactions-dialog.component.html",
    styleUrls: ["./my-transactions-dialog.component.scss"],
})
export class MyTransactionsDialogComponent implements OnInit {
    @Input() walletAddress: string;
    public transactions;
    public tokenSymbol: string;
    public ColumnMode = ColumnMode;
    public totalAmount: number = null;
    constructor(
        private _thisDialog: NbDialogRef<MyTransactionsDialogComponent>,
        private _aS: ApiService,
        private numberPipe: DecimalPipe
    ) {}

    source: LocalDataSource = new LocalDataSource();
    settings = {
        mode: "external",
        hideSubHeader: true,
        reset: true,

        actions: {
            custom: [
                {
                    name: "onView",
                    title: '<img src="../../../../assets/images/maximize-outline.svg" width="25px" height="25px"></img>',
                },
            ],
            edit: false,
            delete: false,
            add: false,
        },
        // Properties of smart table
        columns: {
            txHash: {
                title: "Transaction Hash",
                type: "string",
                filter: false,
            },

            amount: {
                title: "Paid amount",
                type: "string",
                filter: false,
                valuePrepareFunction: (amount) => {
                    amount = this.numberPipe.transform(amount, "1.0-2");
                    return amount;
                },
            },

            paidTokenSymbol: {
                title: "Paid with",
                type: "string",
                filter: true,
            },
            tokensToBeReleased: {
                title: "Bought amount",
                type: "number",
                filter: false,
                valuePrepareFunction: (amount) => {
                    return this.numberPipe.transform(amount, "1.0-2");
                },
            },
            customTokenSymbol: {
                title: "Token bought",
                type: "string",
                filter: true,
            },
            // tokenSymbol: {
            //     title: 'Token Symbol',
            //     type: "string",
            //     valuePrepareFunction: (tokenSymbol) => {
            //         return this.tokenSymbol
            //     }
            // },
            updatedAt: {
                title: "Date and time",
                type: "date",
                sort: true,
                sortDirection: "desc",
                filter: false,

                valuePrepareFunction: (createdAt) => {
                    return (
                        new Date(createdAt).toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                        }) +
                        " " +
                        new Date(createdAt).toLocaleTimeString("en-US", {
                            hour12: false,
                        })
                    );
                },
            },
        },
    };

    ngOnInit(): void {
        this.tokenSymbol = this._aS.tokenSymbol;
        console.log(this.walletAddress);
        this._aS
            .getTransactionsForWallet(this.walletAddress)
            .subscribe((transactions) => {
                this.transactions = transactions;
                console.log(transactions);
                this.source.load(this.transactions);
                this.transactions.forEach((element) => {
                    if (typeof element.amount == "number") {
                        this.totalAmount += element.amount;
                    }
                });
            });
    }

    onClose() {
        this._thisDialog.close();
    }
    onView(event) {
        window.open("https://testnet.cronoscan.com/tx/" + event.data.txHash);
    }
}
